<template>
    <v-container class="container-view prp-table-container_">
        <h2>Resultados CGU</h2>
        <v-row no-gutters>
            <v-col cols="12" md="6"> 
                <table style="width:75%">
                    <tr>
                        <th >
                            Ganador
                        </th>
                       <th>
                           Votos
                       </th>
                    </tr>
                    <tr>
                         <td>
                            <i class="fas fa-shield-alt"></i>{{ winner[0].name }}
                        </td>
                        <td>
                            {{ winner[0].total }}
                        </td>
                    </tr>
                </table><br>
                 <apexchart
                    type="donut"
                    width="75%"
                    :options="chartOptionsResults"
                    :series="seriesResult"
                ></apexchart>
            </v-col>
            <v-col cols="12" md="6">
               
                <scale-loader
                    class="prp-table-loader"
                    v-if="loading"
                    color="black"
                ></scale-loader>
                <h3>Contendientes</h3><br>
                <v-data-table
                    :items="tableListContenders"
                    :headers="headersResultsContenders"
                     hide-default-footer
                     class="elevation-1"
                     style="width:95%"
                >
                </v-data-table>
                <h3>Participación</h3><br>
                <v-data-table 
                :items="tableListResults" 
                :headers="headersTablesResults" 
                hide-default-footer
                class="elevation-1" text-center
                style="width:95%"
                >    
                </v-data-table>
            </v-col>
        </v-row>
        <template> </template>
    </v-container>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'votesResults',
    props: ['loadResultsContenders'],
    components: {
        ScaleLoader,
        apexchart: VueApexCharts,
    },

    data: () => ({
        loading: false,
        seriesResult: [],
        tableListContenders: [],
        tableListResults: [],
        headersResultsContenders: [
            { text: 'Contiende', value: 'contenders' },
            { text: 'Votos', value: 'votes' },
        ],
        headersTablesResults: [
                { text: 'Padrón',          value: 'padron' },
                { text: 'Participación',   value: 'participacion' },
                { text: '% Participación', value: 'p-part' },
        ],
        chartOptionsResults: {
            chart: {
                height: 350,
                type: 'donut',
            },
            // colors: ['#2E93fA'],
            colors: ['#FFFF00', '#0000FF','#9933CC','#FF9900','#90BBD8','#FF0000','#339933'],

            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
            xaxis: {
                categories: [],
                labels: {
                    style: {
                        // colors: colors,
                        fontSize: '12px',
                    },
                },
            },
        },
    }),
    methods: {
        loadVotesResults: function () {
           
            this.jsondata = this.loadResultsContenders;
            let array = [];
            let array_name = [];
            let array_total = [];
            let winner = [];
            let part = [];
            for (let element in JSON.parse(JSON.stringify(this.jsondata))) {
                let obj_part = {'padron': this.jsondata[element].participacion.padron, 'participacion': this.jsondata[element].participacion.totalparticipacion, 'p-part': this.jsondata[element].participacion.porcentajeparticipacion};
                part.push(obj_part);

                for (let i in JSON.parse(
                    JSON.stringify(this.jsondata[element].votos)
                )) {
                    let obj = {
                        contenders: this.jsondata[element].votos[i]['name'],
                        votes: this.jsondata[element].votos[i]['total'],

                    };
                    array.push(obj);
                    array_name.push(this.jsondata[element].votos[i]['name'])
                    array_total.push(this.jsondata[element].votos[i]['total'])    
                    // console.log(array_total);
                }
                    winner.push(this.jsondata[element].winner)
                
            }
            this.tableListContenders = array;
            this.tableListResults = part;
            this.chartOptionsResults.labels = array_name;
            this.winner = winner;
            
            // this.seriesResult = [{data:array_total}];
            this.seriesResult = array_total;            
            
        },
    },

    created() {
        this.loadVotesResults();
    },
};
</script>
<style lang="scss">
.prp-table-container_ {
    position: relative;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    padding: 1rem;
    width: 100%;
    background-color: $votex-gray-background;
}
</style>